import { toGoLangInvoke, safeInteropRegister } from "../common/windowFunctions";
import uuid from "uuid-random";
import { logStatus } from "../utils";
export class SystemManagerClientImpl {
    constructor(gluePromise, asyncConstructors, loggerClient) {
        this.asyncConstructors = asyncConstructors;
        this.loggerClient = loggerClient;
        const pw = asyncConstructors.addConstructor();
        gluePromise.then((g) => {
            this.glue = g;
            asyncConstructors.finishConstructor(pw);
        });
    }
    logStatus(method, type, data) {
        logStatus(this.loggerClient, this.glue, {
            api: "SystemManagerClient",
            method, type, data
        });
    }
    publishCheckpointState() {
    }
    async waitForBootStage(stage, when, callback) {
        this.logStatus("waitForBootStage", "start", { stage, when });
        await this.asyncConstructors.ready();
        const channel = `Finsemble:waitForBootStage:${uuid()}`;
        await this.glue.interop.register(channel, safeInteropRegister(async () => {
            this.loggerClient.log(`waitForBootStage ${stage}: received signal`);
            callback();
        }));
        const { err } = await toGoLangInvoke(() => this.glue.interop.invoke("FSBL.SystemManagerClient.waitForBootStage", {
            channel,
            stage,
            when
        }));
        if (err) {
            this.logStatus("waitForBootStage", "error", err.toString());
        }
        this.logStatus("waitForBootStage", "return");
    }
}
